import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getClassNameGenerator } from 'helper/className';

const HeaderTitle = ({ className, children }) => (
  <div className={classNames(className, HeaderTitle.className)}>
    {children}
  </div>
);

HeaderTitle.className = 'header-title';
HeaderTitle.getClassName = getClassNameGenerator(HeaderTitle.className);

HeaderTitle.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any
};

HeaderTitle.defaultProps = {

};

export default HeaderTitle;
